import Card from './Card';
import DashboardLayout from 'Authentic/Layout/DashboardLayout/DashboardLayout'

const Dashboard = () => {

 

    return (<>


   

        <DashboardLayout>

            

            <Card />

        </DashboardLayout>




    </>)
}

export default Dashboard